<script>
	import { slides } from "../config";

	export let id;
	export let color;
	export let background;

	export let content = {};
</script>

<section {id}>
	<div class="content">
		<div class="title">{content.title}</div>

		<div class="attrs">
			{content.attributions}
		</div>
	</div>
</section>

<style lang="scss">
	section {
		background: #f7f7f7;
		padding: 40px 0 40px 0;
		color: #979797;
		font-size: 16px;
		line-height: 23px;
		font-family: $ff-sans;
		height: auto;
		max-height: none;
		min-height: 0;
	}

	.content {
		width: calc(100% - 40px);
		max-width: 1200px;
		margin: 0 auto;
	}

	.title {
		font-weight: 600;
		margin-right: 20px;
		display: inline-block;
	}

	.attrs {
		display: inline-block;
	}
</style>
